module.exports = __webpack_public_path__ + "img/hyena-howl.19559a4c.png";